import { css } from "styled-components";

export const LinkStyles = css(({ theme }) => ({
    a: {
        ".Typography": {
            color: theme.palette.primary,
        },
    },
}));
